import { Routes } from '@angular/router'
import { DisclaimerComponent } from './pages/disclaimer/disclaimer.component'
import { PrivacyComponent } from './pages/privacy/privacy.component'
import { LandingComponent } from './pages/research/landing/landing.component'
import { UserComponent } from './pages/user/user.component'
import { ResearchComponent } from './pages/research/research.component'
import { HistoryComponent } from './pages/research/history/history.component'
import { BookmarksComponent } from './pages/research/bookmarks/bookmarks.component'
import { DocumentsComponent } from './pages/research/documents/documents.component'
import { TopicsComponent } from './pages/research/topics/topics.component'
import { ChatComponent } from './components/chat/chat.component'
import { HelpComponent } from './pages/help/help.component'
import { PagesComponent } from './pages/pages.component'

export const routes: Routes = [
   { path: '', component: LandingComponent},
   { path: 'pages', component: PagesComponent, children: [
      { path: 'disclaimer', component: DisclaimerComponent},
      { path: 'privacy', component: PrivacyComponent},
      { path: 'help', component: HelpComponent},
      { path: 'user', component: UserComponent, children: []},
   ]},
   {
      path: 'research', component: ResearchComponent, children: [
         { path: 'new', component: LandingComponent },
         { path: 'bookmarks', component: BookmarksComponent },
         { path: 'documents', component: DocumentsComponent },
         { path: 'history', component: HistoryComponent },
         { path: 'topics', component: TopicsComponent },
         { path: '**', component: ChatComponent },
      ]},
]
